import {IJsonPatch} from './jsonPatch';
import {commuteRtL} from './commute';
import {inverse} from './inverse';

/**
 * Given a patch history (array of patches) and a single patch, rooted
 * at the same starting document context d1, rebase patch onto history
 * so that d1 + history -> d2, d2 + patch -> d3
 * @param {array<array>} history array of JSON Patch
 * @param {array} patch JSON Patch
 * @returns {array} rebased patch which can be applied after history
 */
export function rebase(history:Array<Array<IJsonPatch>>, patch:Array<IJsonPatch>)
{
    return history.reduce(
        (commuted, patchFromHistory) => commuteRtL(inverse(patchFromHistory), commuted),
        patch
    );
};
